import { render, staticRenderFns } from "./personalCenterLayout.vue?vue&type=template&id=c7b23c3a&scoped=true&"
import script from "./personalCenterLayout.vue?vue&type=script&lang=js&"
export * from "./personalCenterLayout.vue?vue&type=script&lang=js&"
import style0 from "./personalCenterLayout.vue?vue&type=style&index=0&id=c7b23c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b23c3a",
  null
  
)

export default component.exports